var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "box" }, [
    _c("div", { staticClass: "participan-header" }, [
      _c("div", { staticClass: "columns is-vcentered" }, [
        _c("div", { staticClass: "column" }, [
          _c("small", { staticClass: "has-text-grey-light" }, [
            _vm._v(" " + _vm._s(_vm.$t("debtor")) + " "),
          ]),
          _c("h3", { staticClass: "has-text-black m-0" }, [
            _vm._v(_vm._s(_vm.debtor.fullName)),
          ]),
        ]),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "participan-tags" },
      [
        _c(
          "b-tag",
          {
            attrs: {
              type: "is-primary is-light mr-4",
              icon: "fingerprint",
              "data-cy": "id-number",
              rounded: "",
            },
          },
          [_vm._v(" " + _vm._s(_vm.debtor.idNumber) + " ")]
        ),
        _vm.debtor.birthdate !== "" &&
        _vm.debtor.birthdate !== null &&
        _vm.debtor.birthdate !== "0000-00-00"
          ? _c(
              "b-tag",
              {
                attrs: {
                  type: "is-primary is-light mr-4",
                  icon: "calendar-days",
                  "data-cy": "birthdate",
                  rounded: "",
                },
              },
              [
                _vm._v(
                  " " + _vm._s(_vm.beforeFormatDate(_vm.debtor.birthdate)) + " "
                ),
              ]
            )
          : _vm._e(),
        _c(
          "b-tag",
          {
            attrs: {
              type: "is-primary is-light mr-4",
              icon: "envelope",
              rounded: "",
            },
          },
          [_vm._v(" " + _vm._s(_vm.debtor.email) + " ")]
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "evaluations-documents" },
      [
        _vm._l(_vm.evidenceData, function (document, index) {
          return _c(
            "b-button",
            {
              key: index,
              attrs: {
                size: "is-small",
                type: "mr-4",
                "icon-left": "download",
                tag: "a",
                href: `data:application/pdf;base64,${document.pdfBase64}`,
                download: document.pdfFileName,
                rounded: "",
              },
            },
            [_vm._v(" " + _vm._s(document.pdfFileName) + " ")]
          )
        }),
        _c("input", {
          ref: "fileInput",
          attrs: { type: "file", accept: "application/pdf", hidden: "" },
          on: { change: _vm.handleFileUpload },
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }